var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterHollowDark = function SvgFilterHollowDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.017 3.87h15.091M2.017 8.937h15.091M2.017 14.004h15.091",
    stroke: "#34389F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.519,
    cy: 8.714,
    r: 1.5,
    fill: "#FFF",
    stroke: "#34389F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.167,
    cy: 3.716,
    r: 1.5,
    fill: "#FFF",
    stroke: "#34389F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.178,
    cy: 14.243,
    r: 1.5,
    fill: "#FFF",
    stroke: "#34389F"
  })));
};
export default SvgFilterHollowDark;